<template>
    <div id="app" :style="theme" :class="brightness"><slot></slot></div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import cacheService from "@/services/cache";

export default {
    methods: {
        ...mapActions("brand/", ["populate"])
    },
    computed: {
        theme() {
            const colors = {
                color1: "grey",
                color2: "grey",
                color3: "grey",
                color4: "grey"
            };
            Object.assign(colors, cacheService.getBrandColors());

            return {
                ...Object.keys(colors).reduce((result, key) => {
                    result[`--${key}`] = colors[key];
                    return result;
                }, {})
            };
        },
        ...mapGetters({
            brightness: "brand/getTheme"
        })
    },
    created() {
        this.populate();
    }
};
</script>



// WEBPACK FOOTER //
// theme.vue?140dd592